var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UplotVue',{staticStyle:{"min-height":"370px"},attrs:{"data":_vm.datacollection,"options":_vm.options,"target":_vm.target}})}
var staticRenderFns = []

export { render, staticRenderFns }